import React from 'react';
import FitnessProfileSectionCard from '../shared/FitnessProfileSectionCard';

export default function FitnessProfileCurrentHabitsSection({ questionnaire }) {
	if (!questionnaire) return null;

	return (
		<div className="mt-4">
			<FitnessProfileSectionCard title="Current Habits" subtitle="From your latest lifestyle questionnaire">
				<ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm text-gray-700 dark:text-gray-300">
					<li>
						<span className="text-gray-500 dark:text-gray-400">Diet: </span>
						{questionnaire.diet_pattern_label || questionnaire.diet_pattern}
					</li>
					<li>
						<span className="text-gray-500 dark:text-gray-400">Activity: </span>
						{questionnaire.exercise_frequency_label || questionnaire.exercise_frequency}
					</li>
					<li>
						<span className="text-gray-500 dark:text-gray-400">Intensity: </span>
						{questionnaire.exercise_intensity_label || questionnaire.exercise_intensity}
					</li>
					<li>
						<span className="text-gray-500 dark:text-gray-400">Sleep: </span>
						{questionnaire.sleep_hours} hrs/night
					</li>
				</ul>
				{(questionnaire.diet_notes || questionnaire.habit_notes) && (
					<div className="mt-4 space-y-2 text-sm text-gray-600 dark:text-gray-400">
						{questionnaire.diet_notes && (
							<p>
								<span className="font-medium text-gray-700 dark:text-gray-300">Diet notes: </span>
								{questionnaire.diet_notes}
							</p>
						)}
						{questionnaire.habit_notes && (
							<p>
								<span className="font-medium text-gray-700 dark:text-gray-300">Training notes: </span>
								{questionnaire.habit_notes}
							</p>
						)}
					</div>
				)}
			</FitnessProfileSectionCard>
		</div>
	);
}
